var cookie = require('cookie_js/cookie.min');
var i18n = require('./i18n.json');
var AR = require('component/core/core.js');

/**
 * Тур по странице
 */
class Tour {
	constructor (config) {
		this.cookieName = `tourPassed_${config.id}_${AR.lang}`;
		this.config = config;
		this.config.i18n = i18n[AR.lang];
		this.config.cookieName = this.cookieName;
	}

	/**
	 * Начать тур по странице
	 */
	start () {
		require.ensure(['hopscotch', './hopscotch.css'], require => {
			const hopscotch = require('hopscotch');
			require('./hopscotch.css');
			hopscotch.startTour(this.config);
		});
	}

	/**
	 * Начать тур по странице единожды (если тур уже был показан, то не показывать ещё раз)
	 */
	startFirstTime () {
		if (!cookie(this.cookieName)) {
			this.start();
			cookie.set(this.cookieName, 'true', {
				expires: 365
			});
		}
	}
};

/** @global */
global.Tour = Tour;
/** Tour */
module.exports = Tour;



/** WEBPACK FOOTER **
 ** ./frontend/components/tour/tour.js
 **/